import React, { useEffect, useState } from "react";
import "../Styles/BrowseAgents.css";
import { FaMapMarkerAlt } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import Logo from "../assests/images/agent-login-signup-top-logo.png"; // Adjust path if needed
import LangIcon from "../assests/images/lang-icon.png";
import {
  get_all_agents,
  get_castes,
  get_communities,
  get_language,
  get_religios,
} from "../api/serverWrapper";
import { Link, useNavigate } from "react-router-dom";

const RatingStars = ({ rating }) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 !== 0;
  return (
    <div className="agent-browse-rating-stars">
      {Array.from({ length: fullStars }).map((_, i) => (
        <span key={i}>★</span>
      ))}
      {halfStar && <span>☆</span>}
      {Array.from({ length: 5 - Math.ceil(rating) }).map((_, i) => (
        <span key={i + 5}>☆</span>
      ))}
    </div>
  );
};

function DisplayAgentsForClient() {
  const navigate = useNavigate();
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [religion, setReligion] = useState([]);
  const [caste, setCaste] = useState([]);
  const [community, setCommunity] = useState([]);
  const [allAgents, setAllAgents] = useState([]);
  const [religionOptions, setReligionOptions] = useState([]);
  const [casteOptions, setCasteOptions] = useState([]);
  const [communityOptions, setCommunityOptions] = useState([]);
  const [languages, setLanguage] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    let resp = await get_all_agents();
    console.log(resp.data[0]);

    setAllAgents(resp.data);

    let religion = await get_religios();
    const religionData = religion.data.map((item) => ({
      value: item.ReligionId,
      label: item.ReligionName,
    }));
    setReligionOptions(religionData);
    let caste = await get_castes();
    const casteData = caste.data.map((item) => ({
      value: item.CasteId,
      label: item.CasteName,
    }));
    setCasteOptions(casteData);
    let communitie = await get_communities();
    const communitieData = communitie.data.map((item) => ({
      value: item.CommunitiesId,
      label: item.CommunitiesName,
    }));
    setCommunityOptions(communitieData);
    let lang = await get_language();
    setLanguage(lang.data);
  };

  const handleBrowseAllAgents = () => {
    navigate("/browseagents");
  };

  const handleCreateNewClientForProfile = () => {
    navigate("/client_setup");
  };
  const loginType = "Client";

  return (
    <div className="">
      {/* Header */}
      <header className="agent-browse-header agent-browse-header-fixed ">
        <div className="">
          <img src={Logo} alt="WedLuk Logo" className="agent-browse-logo" />
        </div>
        <div
          style={{ cursor: "pointer" }}
          className="agent-browse-title-name"
          onClick={() => navigate("/agent", { state: { loginType } })}
        >
         Client Login
        </div>
      </header>
      <div className="agent-browse-scroll-wrapper">
        {!selectedPartner && (
          <div className="agent-browse-container">
            <div className="agent-browse-card-grid-for-client">
              <div className="title-for-agents">
                No worries! You can still get expert help — just choose from our
                list of trusted, registered agents to guide you through the
                process and improve your chances.
              </div>

              <div className="agent-browse-card-grid">
                {allAgents.slice(0, 3).map((partner, idx) => (
                  <div
                    key={idx}
                    className="agent-browse-card click-effect"
                    onClick={() => handleBrowseAllAgents()}
                  >
                    <div className="agent-browse-card-header">
                      <div className="agent-browse-name">
                        {partner.BusinessName}
                      </div>

                      <IoIosArrowForward className="agent-browse-arrow-icon" />
                    </div>

                    <RatingStars rating={partner.Rateings} />

                    <div className="d-flex align-items-center justify-content-between">
                      <div className="agent-browse-info-row">
                        <FaMapMarkerAlt className="agent-browse-icon" />
                          <span>
                          {partner?.User?.Address?.CityId ?? "NA"}{" "}
                          {partner?.User?.Address?.StateId ?? "NA"}{" "}
                          {partner?.User?.Address?.CountryId ?? "NA"}
                        </span>
                      </div>

                      <div className="agent-browse-info-row">
                        <img
                          className="icons-for-partner"
                          src={LangIcon}
                          alt=""
                        />
                        {(() => {
                          const matchedLanguages = languages.filter((item) =>
                            partner.LanguagesServe.includes(item.LangId)
                          );
                          const visibleLanguages = matchedLanguages.slice(0, 2);
                          const remainingCount =
                            matchedLanguages.length - visibleLanguages.length;

                          return (
                            <>
                              {visibleLanguages.map((item) => (
                                <span key={item.LangId}>{item.LangDesc}</span>
                              ))}
                              {remainingCount > 0 && (
                                <span> +{remainingCount} more</span>
                              )}
                            </>
                          );
                        })()}
                      </div>
                    </div>

                    <div className="agent-browse-saperator-line"></div>

                    <p className="agent-browse-description">
                      {partner.BusinessDescription}
                    </p>
                  </div>
                ))}
              </div>

              <div
                className="d-flex justify-content-end"
                onClick={handleBrowseAllAgents}
              >
                <button className="Browse-agent-link">
                  Browse all Agents <IoIosArrowForward />
                </button>
              </div>
            </div>
            <div className="continue-card">
              <span className="continue-text">
                Prefer to do this on your own?
              </span>
              <button
                className="continue-link"
                onClick={handleCreateNewClientForProfile}
              >
                Continue without an agent <IoIosArrowForward />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default DisplayAgentsForClient;
